import React, {  } from 'react';
import './modalWrapper.scss';
import { ModalDeviceLogin } from './device-login/modal-device-login';
import { modalTypeEnum } from '../../../types/modal';
import { ModalRegisterOrLogin, RegisterWrapper } from './register-or-login/modal-register-login';
import { useAppDispatch, useAppSelector } from '../../../features';
import { getIsRegisterStatus, setModalSignInUp } from '../../../store/AppSlice';
import { ModalNpos } from './modal-npos';
import { ModalUnauthorized } from './modal-401';
import { getModalErrorMessage } from '../../../store/NotificationSlice';
import { ModalBadPassword } from './modal-bad-password';
import { ModalWithdrawal } from './withdrawal/modal-withdrawal';
import { ModalInfoSlippage } from './modal-info-slippage';
import { ModalReceipt } from './modal-content-receipt/modal-receipt';
import { setReceiptData, setReceiptStatus } from '../../../store/ReceiptSlice';
import { ModalServerError } from './server-error/server';
import { ModalMaintenance } from './maintenance/modal-maintenance';
import { ModalInvalideNpos } from './invalide-npos/invalidate';
import { fetchNposList } from '../../../store/NposSlice';
import { setBlockChainVerificationPharse } from '../../../store/RegisterSlice';

type ModalProps = {
    type: modalTypeEnum;
};

export const ModalWrapper: React.FC<ModalProps> = ({ type }) => {
    const dispatch = useAppDispatch();

    const message       = useAppSelector(getModalErrorMessage) || 'Custom error message';
    const isRegistering = useAppSelector(getIsRegisterStatus);

    const className = `modal-wrapper ${type > 0 ? 'show' : 'hide'}`;
    let Component: React.ElementType | null = null;

    switch (type) {
        case modalTypeEnum.register:
            Component = RegisterWrapper;
            break;
        case modalTypeEnum.deviceLogin:
            Component = ModalDeviceLogin;
            break;
        case modalTypeEnum.walletLogin:
            Component = ModalDeviceLogin;
            break;
        case modalTypeEnum.npos:
            Component = ModalNpos;
            break;
        case modalTypeEnum.unauthorized:
            Component = ModalUnauthorized;
            break;
        case modalTypeEnum.badPassword:
            Component = ModalBadPassword;
            break;
        case modalTypeEnum.withdrawal:
            Component = ModalWithdrawal;
            break;
        case modalTypeEnum.infoSlippage:
            Component = ModalInfoSlippage;
            break;
        case modalTypeEnum.receipt:
            Component = ModalReceipt;
            break;
        case modalTypeEnum.serverError:
            Component = ModalServerError;
            break;
        case modalTypeEnum.invalideteNpos:
            Component = ModalInvalideNpos;
            break;
        case modalTypeEnum.maintenance:
            Component = ModalMaintenance;
            break;
        default:
            return null;
    }

    const dismiss = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        dispatch(setModalSignInUp(modalTypeEnum.none));
        dispatch(setReceiptStatus(false));
        dispatch(setReceiptData(null));
        dispatch(setBlockChainVerificationPharse(``))
        e.stopPropagation();
    };

    const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
    };

    return (
        <div className={className} onClick={dismiss}>
            <div className={`modal-content ${type === modalTypeEnum.infoSlippage ? 'info' : ''}`} onClick={stopPropagation}>
                {Component && <Component message={message} isRegistered={isRegistering} />}
            </div>
        </div>
    );
};